import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-2xl text-sm font-semibold transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pink-300 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-gradient-to-r from-pink-300 to-pink-400 text-white shadow-lg shadow-pink-200/40 hover:shadow-xl hover:shadow-pink-200/50 hover:-translate-y-0.5 active:translate-y-0",
        destructive:
          "bg-gradient-to-r from-red-300 to-red-400 text-white shadow-lg shadow-red-200/40 hover:shadow-xl hover:shadow-red-200/50 hover:-translate-y-0.5",
        outline:
          "border-2 border-pink-200 bg-white/80 shadow-sm hover:bg-pink-50 hover:border-pink-300 text-pink-600",
        secondary:
          "bg-gradient-to-r from-purple-300 to-purple-400 text-white shadow-lg shadow-purple-200/40 hover:shadow-xl hover:shadow-purple-200/50 hover:-translate-y-0.5",
        ghost: "hover:bg-pink-50 text-pink-600",
        link: "text-pink-500 underline-offset-4 hover:underline hover:text-pink-600",
        mint: "bg-gradient-to-r from-green-300 to-green-400 text-white shadow-lg shadow-green-200/40 hover:shadow-xl hover:-translate-y-0.5",
        lavender: "bg-gradient-to-r from-purple-200 to-purple-300 text-purple-700 shadow-lg shadow-purple-200/40 hover:shadow-xl hover:-translate-y-0.5",
        pastel: "bg-gradient-to-r from-pink-100 to-purple-100 text-pink-600 hover:from-pink-200 hover:to-purple-200",
      },
      size: {
        default: "h-10 px-5 py-2",
        sm: "h-8 rounded-xl px-4 text-xs",
        lg: "h-11 rounded-2xl px-8",
        icon: "h-10 w-10 rounded-xl",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
